module.exports = __webpack_public_path__ + "fonts/Yekan.1008c3b8.ttf";